export interface TourStep {
  element: string;
  intro: string;
  waitFor: boolean;
  async?: boolean;
  highlightElement?: string;
}

export const tourStepsBig: TourStep[] = [
  {
    element: "#add_item_step1",
    intro: "Click here to add your item to another board.",
    waitFor: true,
  },
  {
    element: "#add_item_step2",
    intro: "Select a workspace in your account.",
    waitFor: true,
    async: true,
    highlightElement: ".add-item-dropdown",
  },
  {
    element: "#add_item_step3",
    intro: "Select the board you'd like to add your item to.",
    waitFor: true,
    highlightElement: ".add-item-dropdown",
  },
  {
    element: "#add_item_step4",
    intro: "Select which group to add the item to",
    waitFor: true,
    highlightElement: ".add-item-dropdown",
  },
];

export const tourStepsSmall: TourStep[] = [
  {
    element: "#add_item_step1",
    intro: "Click here to add your item to another board.",
    waitFor: true,
  },
  {
    element: "#add_item_step_2_small",
    intro: "Select a workspace in your account. Then select a board.",
    waitFor: true,
    async: true,
    highlightElement: ".add-item-dropdown",
  },
  {
    element: "#add_item_step_3_small",
    intro: "Select which group to add the item to",
    waitFor: true,
  },
];
